export default __webpack_public_path__ + "static/media/awaiting4.7a0953be.svg";